const Footer = () => {
  return (
    <div>
      <h4 className="text-center text-white text-focus-in">
        Product by ❤️ Midnight
      </h4>
    </div>
  );
};

export default Footer;
